import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { getUserSchema, getEmployeeSchema, uiSchema } from './Schema';
import PhoneInputField from './PhoneInputField';
import './UserEditor.scss';
import validate from './validations';
import transformErrors from './utils';
import LoadingOverlay from '../LoadingOverlay';

export default class UserEditor extends PureComponent {
  onSubmit = ({ formData }) => {
    this.props.onSave(formData);
  };

  render() {
    const {
      fetching,
      user,
      dealer,
      currentUser,
      isEmployeeRoute,
      accessibleRoles,
    } = this.props;
    const schema = isEmployeeRoute
      ? getEmployeeSchema({ user, currentUser, accessibleRoles })
      : getUserSchema({ user, dealer, accessibleRoles });

    return (
      <div className="user-list-container">
        <LoadingOverlay active={fetching}>
          <Form
            schema={schema}
            uiSchema={uiSchema}
            formData={user}
            validate={validate}
            transformErrors={transformErrors}
            onSubmit={this.onSubmit}
            fields={{ phone: PhoneInputField }}
            enctype="multipart/form-data"
          >
            <Button
              bsClass="btn btn-primary btn-large"
              disabled={fetching}
              type="submit"
            >
              Save
            </Button>
          </Form>
        </LoadingOverlay>
      </div>
    );
  }
}

UserEditor.propTypes = {
  fetching: PropTypes.bool,
  user: PropTypes.object,
  dealer: PropTypes.object,
  currentUser: PropTypes.object,
  onSave: PropTypes.func,
  accessibleRoles: PropTypes.array,
  isEmployeeRoute: PropTypes.bool,
};
